import React from 'react';

export default function Languagealternate(props) {
  const { language, url } = props;
  return (
    <link rel="alternate" hreflang={language} href={url} />
  );
}
